import {
	DefaultButton,
	Dialog,
	DialogFooter,
	DialogType,
	Spinner,
	Stack,
	StackItem,
} from '@fluentui/react';
import { People, PersonCardInteraction } from '@microsoft/mgt-react';
import { observer } from 'mobx-react';
import React from 'react';
import { IVersion, IVersionChangeProperty } from '../../API';
import VersionHistoryState from '../../state/VersionHistoryState';

export interface IVersionHistoryProps {
	state: VersionHistoryState;
}

export class VersionHistory extends React.Component<IVersionHistoryProps, {}> {
	render() {
		const modelProps = {
			isBlocking: false,
			styles: { main: { minWidth: '800px !important' } },
		};

		const dialogContentProps = {
			type: DialogType.normal,
			title: 'Version history',
		};

		return (
			<Dialog
				dialogContentProps={dialogContentProps}
				modalProps={modelProps}
				hidden={!this.props.state.visible}
				onDismiss={() => {
					this.props.state.setVisible(false);
				}}
			>
				{this.props.state.loading && <Spinner />}
				{!this.props.state.loading && this.getVersionHistory()}

				<DialogFooter>
					<DefaultButton
						style={{ width: 100 }}
						onClick={() => {
							this.props.state.setVisible(false);
						}}
					>
						Close
					</DefaultButton>
				</DialogFooter>
			</Dialog>
		);
	}

	private getVersionHistory(): React.ReactNode {
		return (
			<Stack>
				{this.props.state.versions.map((version) => {
					return <StackItem>{this.getVersion(version)}</StackItem>;
				})}
			</Stack>
		);
	}

	private getVersion(version: IVersion): React.ReactNode {
		return (
			<Stack horizontal style={{ marginBottom: 15 }}>
				<StackItem>
					<People
						personCardInteraction={PersonCardInteraction.hover}
						userIds={[version.modifiedBy]}
					/>
				</StackItem>
				<StackItem>
					<Stack style={{ marginTop: 4 }}>
						<StackItem style={{ fontStyle: 'italic', fontSize: 'smaller' }}>
							{version.modifiedDate.toLocaleDateString() +
								' ' +
								version.modifiedDate.toLocaleTimeString()}
						</StackItem>
						<StackItem>{this.getUpdatedVersionProperties(version.changes)}</StackItem>
					</Stack>
				</StackItem>
			</Stack>
		);
	}

	private getUpdatedVersionProperties(
		changes: IVersionChangeProperty[],
	): React.ReactNode {
		if (changes.length === 0) {
			return <span>First version</span>;
		}

		return (
			<Stack>
				{changes.map((change) => {
					return (
						<StackItem>
							<span>
								{this.props.state.getColumnDisplayName(change.internalName)}:{' '}
							</span>

							<strong>
								{this.props.state.getFormattedValue(change.internalName, change.after)}
							</strong>

							<span
								style={{
									textDecoration: 'line-through',
									color: '#868686',
									marginLeft: 20,
								}}
							>
								{this.props.state.getFormattedValue(change.internalName, change.before)}
							</span>
						</StackItem>
					);
				})}
			</Stack>
		);
	}
}

export default observer(VersionHistory);
